export default __webpack_public_path__ + "static/media/Arrow Right.42eb16db.svg";